import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Container, Box, Typography, Button, Paper } from '@mui/material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import HomeIcon from '@mui/icons-material/Home';

const ErrorBoundaryPage = function ErrorBoundaryPage() {
  const navigate = useNavigate();
  const intl = useIntl();

  const handleGoHome = () => {
    navigate('/');
    window.location.reload();
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 3,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: '40px 30px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            textAlign: 'center',
          }}
        >
          <ErrorOutlineRoundedIcon
            sx={{
              fontSize: '80px',
              color: 'error.main',
            }}
          />

          <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
            {intl.messages.UNEXPECTED_ERROR}
          </Typography>

          <Typography variant="body1" color="textSecondary" sx={{ my: 2 }}>
            {intl.messages.ERROR_OCCURRED_MESSAGE}
          </Typography>

          <Typography variant="body2" color="textSecondary">
            {intl.messages.CONTACT_SUPPORT}
          </Typography>

          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<HomeIcon />}
            onClick={handleGoHome}
            sx={{ mt: 2 }}
          >
            {intl.messages.BACK_TO_HOME}
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default ErrorBoundaryPage;
